module.exports = __webpack_public_path__ + "static/media/deal-img1.d3940144.jpg";